import React from 'react';
import useSystemUpdate from '../../hooks/useSystemUpdate';
import './UpdatePrompt.scss';

const UpdatePrompt = ({ systemKey = 'project' }) => {
  const { updateInfo, dismiss } = useSystemUpdate(systemKey);

  if (!updateInfo) return null;

  return (
    <div className="update-prompt">
      <div className="update-prompt-content">
        <span className="update-icon">🔄</span>
        <span className="update-text">
          {updateInfo.message || '系統已更新，請重新整理頁面以取得最新版本'}
        </span>
        <button className="update-button" onClick={() => window.location.reload()}>
          立即重新整理
        </button>
        <button className="update-close" onClick={dismiss}>
          ✕
        </button>
      </div>
    </div>
  );
};

export default UpdatePrompt;
